import type { UserRole } from '@/types/api'

export function dashboardPathForRole(role: UserRole): string {
  switch (role) {
    case 'instructor':
      return '/instructor/courses'
    case 'admin':
      return '/admin/users'
    default:
      return '/dashboard'
  }
}
